module.exports = __webpack_public_path__ + "static/media/performance-optimized.9afff341.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/02-blazing-fast/images/performance-optimized.jpg
// module id = 931
// module chunks = 0